import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { PATHS } from "util/appConstants";
import Navbar from "components/Navbar";
import LightLayout from "components/Shared/LightLayout";
import AdminBar from "components/Masterbar/AdminBar";
import UserForm from "components/Users/form";

// Redux actions/selectors
import { getSuppliers, selectSuppliers, selectSuppliersStatus } from "redux/slices/supplierSlice";
import { getSupplierLocations, selectSupplierLocations } from "redux/slices/supplierLocationsSlice";
import { createUser } from "redux/slices/userSlice";


const currentAction = "ADD";

const AddUser = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const suppliers = useSelector(selectSuppliers);
  const supplierLocations = useSelector(selectSupplierLocations);
  const loading = useSelector(selectSuppliersStatus);

  useEffect(() => {
    if (!suppliers.length && !loading) {
      dispatch(getSuppliers());
    }
    dispatch(getSupplierLocations());
  }, [dispatch]);

  const onSubmit = async (payload) => {
    await dispatch(createUser(payload)).then((res) => {
      if (res) {
        history.push(PATHS.admin.users);
      }
    });
  };

  return (
    <>
      <Navbar />
      <AdminBar />
      <LightLayout doublebar>
        <UserForm
          action={currentAction}
          onSubmit={onSubmit}
          suppliers={suppliers}
          supplierLocations={supplierLocations}
        />
      </LightLayout>
    </>
  );
};

export default AddUser;
